/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4));})(navigator.userAgent||navigator.vendor||window.opera);

function timeSince(date) {

    var seconds = Math.floor((new Date() - date) / 1000);

    var interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
        return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
        return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
        return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
        return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
        return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
}

function reset_resource_tile_height() {
        setTimeout(function() {
            jQuery('.equalize-heights .item, .equalize-heights .sub-item').matchHeight({remove: true});
            jQuery('.equalize-heights .item, .equalize-heights .sub-item').matchHeight({remove: true});
            jQuery('.equalize-heights .item, .equalize-heights .sub-item').matchHeight({byRow: true});
            Waypoint.refreshAll();
        }, 300);
}

function calculateConversion(inputGroup) {
    if (jQuery('#currencyConverter').length > 0) {
        var fromClass = '.from';
        var toClass = '.to';

        if (inputGroup.hasClass('to')) {
            fromClass = '.to';
            toClass = '.from';
        }

        var fromAmount = parseFloat(jQuery(fromClass + ' .amount').val().replace(/\D/g,''));
        var fromCurrency = jQuery(fromClass).attr('data-currency');
        var toCurrency = jQuery(toClass).attr('data-currency');

        // console.log("Calculate Currency: " + fromCurrency + ' ' + toCurrency);

        //console.log(fromAmount);
        // var d = new Date(fx.timestamp*1000); //Multiply the unix timestamp by 1000 to use the timestamp in javascript
        jQuery('.exchange-rate').html(parseFloat(fx.getRate(toCurrency, fromCurrency)).toFixed(4));

// console.log(1);
        if (fromAmount !== '' && fromAmount > 0) {
            var toAmount = parseFloat(fx.convert(fromAmount, {from: fromCurrency, to: toCurrency})).toFixed(2);
// console.log(2);

            jQuery(toClass + ' .amount').val(toAmount.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));

            var cost = jQuery(fromClass + ' .amount').val() - toAmount;

            if (cost < 0) {
                cost = cost * -1;
            }

            var savingsRate = 0.008;

            //Now that we have the savings we'll find the saving rate for the amount being converted.
            for (i = 0; i < afxCurrencyRates.length; i++) {
                if (fromAmount >= afxCurrencyRates[i].min && fromAmount <= afxCurrencyRates[i].max) {
                    savingsRate = afxCurrencyRates[i].discount / 100;
                }
            }

            var savingsAmount = '<span class="nowrap">' + parseFloat(toAmount * savingsRate).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + ' ' + toCurrency + '</span>';
            var costDescription = afAjax.afx_savings_description.replace('%%SAVINGS_AMOUNT%%', savingsAmount);
            // console.log(3);

            jQuery('.afx-savings').html(costDescription);
        } else {
            jQuery(toClass + ' .amount').val('');
            jQuery('.afx-savings').html('');
        }
    }
}

var exchangeRatesLoaded = false;

function load_exchange_rates(from) {
    // console.log('Exchange rates loaded', from, exchangeRatesLoaded);

    if (!exchangeRatesLoaded) {
        // console.log('Get currency rates', 'https://www.apilayer.net/api/live?access_key=e811ffd78be777e732ee5ddf976de2f5&source='+(from == 'USD' ? '' : from)+'&format=1');
        // Load exchange rates data via AJAX:
        jQuery.getJSON(
            // NB: using Open Exchange Rates here, but you can use any source!
            'https://www.apilayer.net/api/live?access_key=e811ffd78be777e732ee5ddf976de2f5&source='+(from === 'USD' ? '' : from)+'&format=1',
            function(data) {
                // console.log('Exchange rates', data);

                // Check money.js has finished loading:
                if ( typeof fx !== "undefined" && fx.quotes ) {
                    fx.quotes = data.quotes;
                    fx.source = data.source;
                    fx.timestamp = data.timestamp;
                } else {
                    // If not, apply to fxSetup global:
                    var fxSetup = {
                        quotes : data.quotes,
                        source : data.source,
                        timestamp : data.timestamp
                    };
                }

                //console.log(data);
                exchangeRatesLoaded = true;

                calculateConversion(jQuery('#currencyConverter .from'));
                jQuery('body').trigger('rates:loaded');
            }
        ).error(function(jqXHR, textStatus, errorThrown) {
            console.log('json error text status', textStatus);
            console.log('incoming Text', jqXHR.responseText);
            console.log('json error thrown', errorThrown);
        });
    }
}

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var AgilityForex = {
    // All pages
    'currency_widget': {
      init: function() {
        var $currencyConverter = $('#currencyConverter');

        $('button.convert', $currencyConverter).on('click', function() {
            calculateConversion($('.from', $currencyConverter));
            $('.disclaimer').slideUp(400);
            $('.conversion-details').slideDown(400);
            ga('send', 'event', $currencyConverter.attr('data-ga-category'), 'Show Savings');
        });

        $('.from select', $currencyConverter).val('CAD');

        $('select', $currencyConverter).on('change', function(e) {
            //console.log($(this).val());
            $(this).closest('.input-group').attr('data-currency', $(this).val());
            calculateConversion($('.from', $currencyConverter));

            var fromCurrency = jQuery('.from').attr('data-currency');
            var toCurrency = jQuery('.to').attr('data-currency');

            ga('send', 'event', $currencyConverter.attr('data-ga-category'), 'Currency Pair Selected', fromCurrency+'/'+toCurrency);

            e.preventDefault();
        });

        $('.swap-currency', $currencyConverter).on('click', function() {
            var fromCurrency = jQuery('.from').attr('data-currency');
            var toCurrency = jQuery('.to').attr('data-currency');
            jQuery('.from').attr('data-currency', toCurrency);
            jQuery('.to').attr('data-currency', fromCurrency);
            jQuery('.from select').val(toCurrency);
            jQuery('.to select').val(fromCurrency);

            var fromAmount = jQuery('.from .amount').val();
            var toAmount = jQuery('.to .amount').val();
            jQuery('.from .amount').val(toAmount);
            jQuery('.to .amount').val(fromAmount);
        });
      },
      finalize: function() {
      }
    },
    'common': {
      init: function() {
        console.log('here');
        console.log(document.querySelector('.legal-docs'));

        if (document.querySelector('.legal-docs')) {
            var container = document.querySelector('.legal-docs');
            var tabs = container.querySelectorAll('.tab');
            var mobile_nav = container.querySelector('.tab-mobile-nav');
            var blocks = container.querySelectorAll('.tab-content-wrap > .afx-block, .tab-content-container > .afx-block');
            var content_wrap = container.querySelector('.tab-content-wrap');

            if (tabs.length && blocks.length) {
                blocks.forEach(function(elem, i) {
                    console.log('block');
                    elem.classList.add('pointer-events-none', 'tab-content', 'fade-in-up', 'py-0');
                });

                blocks[0].setAttribute('aria-selected', true);
                tabs[0].setAttribute('aria-selected', true);

                tabs.forEach(function(elem, i) {
                    elem.addEventListener('click', function(e) {
                        e.preventDefault();
                        console.log('tab click');
                        // history.replaceState({}, '', e.target.href);

                        blocks.forEach(function(elem, i) {
                            elem.setAttribute('aria-selected', false);
                        });

                        tabs.forEach(function(elem, i) {
                            elem.setAttribute('aria-selected', false);
                        });

                        blocks[i].setAttribute('aria-selected', true);
                        elem.setAttribute('aria-selected', true);

                        if (mobile_nav && elem.id) {
                            mobile_nav.querySelector('option[value="#' + elem.id + '"]').setAttribute('selected', true);
                        }

                        content_wrap.setAttribute('style', 'height: ' + (blocks[i].querySelector('.block-inner').offsetHeight + 50) + 'px');
                    });
                });

                //Click the tab button if the mobile nav is changed. This will not fire if you click on a tab link.
                if (mobile_nav) {
                    mobile_nav.addEventListener('change', function(e) {
                        var tab = document.querySelector(e.target.value);
                        tab.click();
                    });
                }

                if (window.location.hash) {
                    setTimeout(function() {
                        var selected_content = document.querySelector(window.location.hash);

                        if (selected_content) {
                            var tab = document.querySelector(selected_content.getAttribute('data-tab'));

                            if (tab) {
                                if (mobile_nav) {
                                mobile_nav.querySelector('option[value="' + window.location.hash.replace('#', '#tab') + '"]').setAttribute('selected', true);
                                }

                                tab.click();
                            }
                        }
                    }, 200);
                }

                window.addEventListener('resize', function(event) {
                    content_wrap.setAttribute('style', 'height: ' + (content_wrap.querySelector('.afx-block[aria-selected="true"] .block-inner').offsetHeight) + 'px');
                });

                content_wrap.setAttribute('style', 'height: ' + (content_wrap.querySelector('.afx-block[aria-selected="true"] .block-inner').offsetHeight) + 'px');

                var tab_container = container.querySelector('.tabs');
                tab_container.setAttribute('style', 'max-width: 50px');
                tab_container.setAttribute('style', 'max-width: ' + container.parentElement.offsetWidth + 'px');

                window.addEventListener('resize', function(event) {
                    tab_container.setAttribute('style', 'max-width: 50px');
                    tab_container.setAttribute('style', 'max-width: ' + container.parentElement.offsetWidth + 'px');
                });
            }
        }

        $('.open-lity > a').on('click', function(e) {
//            console.log($(this).attr('href'));
            lity($(this).attr('href'));
            e.preventDefault();
        });

        $('.currency-widget.learn-more').on('click', function() {
            ga('send', 'event', $(this).attr('data-ga-category'), 'Learn More Click');
        });

        if ($('#currencyConverter').length > 0) {
            load_exchange_rates('USD');

            $('body').on('rates:loaded', function() {
                var $currencyConverter = $('#currencyConverter');

                $('.input-group', $currencyConverter).on('keyup', '.amount', function(event) {
                    //console.log($(event.delegateTarget).hasClass('to'));

                    // skip for arrow keys
                    if(event.which >= 37 && event.which <= 40) {
                        return;
                    }

                    // format number
                    $(this).val(function(index, value) {
                        return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    });

                    var fromAmount = parseFloat(jQuery('.from .amount').val().replace(/\D/g,''));

                    if ($(event.delegateTarget).hasClass('to')) {
                        fromAmount = parseFloat(jQuery('.to .amount').val().replace(/\D/g,''));
                    }

                    if (fromAmount !== '' && fromAmount > 0) {
                        calculateConversion($(event.delegateTarget));

                        var fromCurrency = jQuery('.from').attr('data-currency');
                        var toCurrency = jQuery('.to').attr('data-currency');

                        ga('send', 'event', $currencyConverter.attr('data-ga-category'), 'Amount Entered', parseFloat(jQuery('.from .amount').val().replace(/\D/g,'')) + ' ' + fromCurrency + ' to ' + parseFloat(fx.convert(fromAmount, {from: fromCurrency, to: toCurrency})).toFixed(2) + ' ' + toCurrency);
                    }
                });

                // $('.to .amount', $currencyConverter).blur(function() {
                //     calculateConversion();
                // });

                $('.dropdown-menu a', $currencyConverter).on('click', function(e) {
                    $(this).closest('.input-group').attr('data-currency', $(this).attr('data-currency'));
                    $('.btn', $(this).closest('.input-group')).html($(this).html());
                    calculateConversion($('.from', $currencyConverter));

                    var fromCurrency = jQuery('.from').attr('data-currency');
                    var toCurrency = jQuery('.to').attr('data-currency');

                    ga('send', 'event', $currencyConverter.attr('data-ga-category'), 'Currency Pair Selected', fromCurrency+'/'+toCurrency);

                    e.preventDefault();
                });
            });
        }

        $('.gform-account-type-switcher input').on('change', function() {
            if($(this).is(':checked')) {
                var registrationURL = afAjax.personal_signup;

                if ($(this).val() === afAjax.business_signup_label) {
                    registrationURL = afAjax.business_signup;
                }

                window.location.href = registrationURL;
            }
        });

        $('.open-chat a').on('click', function(e) {
            olark('api.box.expand');
            e.preventDefault();
        });

        $('header.header .menu-item-has-children.dropdown > a').on('click', function(e) {
            if (jQuery.browser.mobile) {
                if (!$('.dropdown-menu', $(this).parent()).hasClass('open')) {
                    e.preventDefault();
                }

                $('header.header .dropdown-menu').removeClass('open');
                $('.dropdown-menu', $(this).parent()).addClass('open');
            }
        });

        //Match the height of grid columns
        $('.equalize-content-heights .target-content').matchHeight({byRow: true});
        $('.equalize-heights .item, .equalize-heights .sub-item').matchHeight({byRow: true});
        $('.equalize-heights .block-photo').matchHeight({byRow: true});

        //Scroll to a given anchor point.
        $('.scroll-to-anchor').on('click', function(e) {
            var offset = 160;

            if ($(this).attr('data-offset')) {
                 offset = $(this).attr('data-offset');
            }

            var targetOffset = $($(this).attr('data-target')).offset();

            $('html, body').animate({
                scrollTop: targetOffset.top-offset
            }, 600);

            e.preventDefault();
        });

        $('body').on('click', '#gform_wrapper_6 form .submit-form, #gform_wrapper_7 form .submit-form, #gform_wrapper_8 form .submit-form', function(e) {
            $(this).attr("clicked", "true");
        });

        $('body').on('submit', '#gform_wrapper_6 form, #gform_wrapper_7 form, #gform_wrapper_8 form', function(e) {
            if ($('.LV_invalid_field').length <= 0 && $('.submit-form', $(this)).attr('clicked') === 'true') {
                $(this).addClass('submitting');
                var $pleaseWaitMessage = $('<div id="savingForm" class="saving-form-loader"><div class="loader-inner line-scale"><div></div><div></div><div></div><div></div><div></div></div><div class="message">We are now setting up your account. Please stand by.</div></div>');

                $('body').append($pleaseWaitMessage);

                var lightbox = lity();
                lightbox('#savingForm');
            }
        });

        //Don't let the user pick the same select box twice.
        $('.security-question select').on('change', function() {
            $(".security-question select[id!='" + $(this).attr('ID') + "'] option").show();
            $(".security-question select[id!='" + $(this).attr('ID') + "']").children('option[value^="' + $(this).val() + '"]').hide();
        });

        if ($('.infinite-container').length) {
            //Set up infinite scroll using Waypoints
            var infinite = new Waypoint.Infinite({
                element: $('.infinite-container')[0],
                items: 'article.post',
                more: '.nav-previous a, .nav-links a.next',
                onAfterPageLoad: reset_resource_tile_height
            });
        }

        if(window.location.hash === '#demo') {
            $('.open-demo-form').trigger('click');
        }
      },
      finalize: function() {
        //Remove the disabled input attributes from the demo form input fields.
        setTimeout(function(){
            $('#demoForm input').removeAttr('disabled');
        }, 400);

        //console.log('here');
      }
    }
};

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = AgilityForex;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

function urldecode(str) {
   return decodeURIComponent((str+'').replace(/\+/g, '%20')).replace(/\\'/, "'");
}

// Global array of countries and their respective states
var Countries = [
                    { "name": "United States", "abbr": "US", "states": [{ "name": "Alabama", "abbr": "AL" },
                                                                        { "name": "Alaska", "abbr": "AK" },
                                                                        { "name": "Arizona", "abbr": "AZ" },
                                                                        { "name": "Arkansas", "abbr": "AR" },
                                                                        { "name": "California", "abbr": "CA" },
                                                                        { "name": "Colorado", "abbr": "CO" },
                                                                        { "name": "Connecticut", "abbr": "CT" },
                                                                        { "name": "Delaware", "abbr": "DE" },
                                                                        { "name": "District Of Columbia", "abbr": "DC" },
                                                                        { "name": "Florida", "abbr": "FL" },
                                                                        { "name": "Georgia", "abbr": "GA" },
                                                                        { "name": "Hawaii", "abbr": "HI" },
                                                                        { "name": "Idaho", "abbr": "ID" },
                                                                        { "name": "Illinois", "abbr": "IL" },
                                                                        { "name": "Indiana", "abbr": "IN" },
                                                                        { "name": "Iowa", "abbr": "IA" },
                                                                        { "name": "Kansas", "abbr": "KS" },
                                                                        { "name": "Kentucky", "abbr": "KY" },
                                                                        { "name": "Louisiana", "abbr": "LA" },
                                                                        { "name": "Maine", "abbr": "ME" },
                                                                        { "name": "Maryland", "abbr": "MD" },
                                                                        { "name": "Massachusetts", "abbr": "MA" },
                                                                        { "name": "Michigan", "abbr": "MI" },
                                                                        { "name": "Minnesota", "abbr": "MN" },
                                                                        { "name": "Mississippi", "abbr": "MS" },
                                                                        { "name": "Missouri", "abbr": "MO" },
                                                                        { "name": "Montana", "abbr": "MT" },
                                                                        { "name": "Nebraska", "abbr": "NE" },
                                                                        { "name": "Nevada", "abbr": "NV" },
                                                                        { "name": "New Hampshire", "abbr": "NH" },
                                                                        { "name": "New Jersey", "abbr": "NJ" },
                                                                        { "name": "New Mexico", "abbr": "NM" },
                                                                        { "name": "New York", "abbr": "NY" },
                                                                        { "name": "North Carolina", "abbr": "NC" },
                                                                        { "name": "North Dakota", "abbr": "ND" },
                                                                        { "name": "Ohio", "abbr": "OH" },
                                                                        { "name": "Oklahoma", "abbr": "OK" },
                                                                        { "name": "Oregon", "abbr": "OR" },
                                                                        { "name": "Pennsylvania", "abbr": "PA" },
                                                                        { "name": "Puerto Rico", "abbr": "PR" },
                                                                        { "name": "Rhode Island", "abbr": "RI" },
                                                                        { "name": "South Carolina", "abbr": "SC" },
                                                                        { "name": "South Dakota", "abbr": "SD" },
                                                                        { "name": "Tennessee", "abbr": "TN" },
                                                                        { "name": "Texas", "abbr": "TX" },
                                                                        { "name": "Utah", "abbr": "UT" },
                                                                        { "name": "Vermont", "abbr": "VT" },
                                                                        { "name": "Virgin Islands", "abbr": "VI" },
                                                                        { "name": "Virginia", "abbr": "VA" },
                                                                        { "name": "Washington", "abbr": "WA" },
                                                                        { "name": "West Virginia", "abbr": "WV" },
                                                                        { "name": "Wisconsin", "abbr": "WI" },
                                                                        { "name": "Wyoming", "abbr": "WY"}]
                    },
{ "name": "Canada", "abbr": "CA", "states": [{ "name": "Alberta", "abbr": "AB" },
                                                                    { "name": "British Columbia", "abbr": "BC" },
                                                                    { "name": "Manitoba", "abbr": "MB" },
                                                                    { "name": "New Brunswick", "abbr": "NB" },
                                                                    { "name": "Newfoundland and Labrador", "abbr": "NL" },
                                                                    { "name": "Northwest Territories", "abbr": "NT" },
                                                                    { "name": "Nova Scotia", "abbr": "NS" },
                                                                    { "name": "Nunavut", "abbr": "NU" },
                                                                    { "name": "Ontario", "abbr": "ON" },
                                                                    { "name": "Prince Edward Island", "abbr": "PE" },
                                                                    { "name": "Quebec", "abbr": "QC" },
                                                                    { "name": "Saskatchewan", "abbr": "SK" },
                                                                    { "name": "Yukon", "abbr": "YT"}]
},
{ "name": "Mexico", "abbr": "MX", "states": [
                          { "name": "Aguascalientes", "abbr": "AGS" },
                          { "name": "Baja California Norte", "abbr": "BCN" },
                          { "name": "Baja California Sur", "abbr": "BCS" },
                          { "name": "Campeche", "abbr": "CAM" },
                          { "name": "Chiapas", "abbr": "CHIS" },
                          { "name": "Chihuahua", "abbr": "CHIH" },
                          { "name": "Coahuila", "abbr": "COAH" },
                          { "name": "Colima", "abbr": "COL" },
                          { "name": "Distrito Federal", "abbr": "DF" },
                          { "name": "Durango", "abbr": "DGO" },
                          { "name": "Guanajuato", "abbr": "GTO" },
                          { "name": "Guerrero", "abbr": "GRO" },
                          { "name": "Hidalgo", "abbr": "HGO" },
                          { "name": "Jalisco", "abbr": "JAL" },
                          { "name": "México - Estado de", "abbr": "EDM" },
                          { "name": "Michoacán", "abbr": "MICH" },
                          { "name": "Morelos", "abbr": "MOR" },
                          { "name": "Nayarit", "abbr": "NAY" },
                          { "name": "Nuevo León", "abbr": "NL" },
                          { "name": "Oaxaca", "abbr": "OAX" },
                          { "name": "Puebla", "abbr": "PUE" },
                          { "name": "Querétaro", "abbr": "QRO" },
                          { "name": "Quintana Roo", "abbr": "QROO" },
                          { "name": "San Luis Potosí", "abbr": "SLP" },
                          { "name": "Sinaloa", "abbr": "SIN" },
                          { "name": "Sonora", "abbr": "SON" },
                          { "name": "Tabasco", "abbr": "TAB" },
                          { "name": "Tamaulipas", "abbr": "TAMPS" },
                          { "name": "Tlaxcala", "abbr": "TLAX" },
                          { "name": "Veracruz", "abbr": "VER" },
                          { "name": "Yucatán", "abbr": "YUC" },
                          { "name": "Zacatecas", "abbr": "ZAC"}]
},
{ "name": "Other International", "abbr": "OINT", "states": [] }
];

function generateSelectBox(id, options, selectedValue) {
    var ddl = jQuery('<select id="' + id + '"></select>');
    jQuery(ddl).append(jQuery('<option></option').val('').html(''));
    jQuery.each(options, function (i, item) {
        jQuery(ddl).append(jQuery('<option></option').val(item.name).html(item.name));

        if (selectedValue === item.name) {
            jQuery(ddl).find('option:last').attr('selected', 'selected');
        }
    });
    return jQuery(ddl);
}

// Finds the states that go with selectedCountry, using the Countries object.
function getStatesForCountry(selectedCountry) {
    for (var i in Countries) {
        var country = Countries[i];
        if (selectedCountry === country.name) {
            return country.states;
        }
    }
    return [];
}

// Sets a field's value based on a related dropdown's value
function setFieldFromDropdown(fieldName) {
    var $dropdown = jQuery('#' + fieldName);

    if ($dropdown.length !== 1) {
      return null;
   }

    var selectedValue = $dropdown.find('option:selected:first').val();

    return selectedValue;
}

// Sets the value of the stateOrProvince field to the newly selected value
function handleStateChanged(eventData) {
    var stateFieldName = eventData.data.stateFieldName;
    jQuery('#'+stateFieldName).val(setFieldFromDropdown('ddl_' + stateFieldName));
    jQuery('#' + stateFieldName).trigger('blur').trigger('change');

    //console.log('Blur');
    if (stateFieldName) {
        setTimeout(function(){
            if (jQuery('#'+stateFieldName).hasClass('LV_valid_field')) {
                jQuery('#ddl_' + stateFieldName).addClass('LV_valid_field');
            } else {
                jQuery('#ddl_' + stateFieldName).removeClass('LV_valid_field');
            }
        }, 400);
    }
}

// Configures the stateOrProvince field to be a dropdown dependent on the value of the country dropdown. Values are pulled from the Countries object.
function loadStateField(stateFieldName, selectedCountry) {
    var states = getStatesForCountry(selectedCountry);
    var stateField = jQuery('#' + stateFieldName);
    if (states === null || !jQuery.isArray(states) || states.length < 1) {
        jQuery('#ddl_' + stateFieldName).remove();
        jQuery(stateField).show().removeClass('invisible');
        return;
    }

    jQuery(stateField).addClass('invisible');
    var selectedState = jQuery('#'+stateFieldName).val();
    var stateDropdown = generateSelectBox('ddl_' + stateFieldName, states, selectedState);
    var existingDropdown = jQuery('#ddl_' + stateFieldName);

    if (jQuery(existingDropdown).length < 1) {
        jQuery('#' + stateFieldName).before(jQuery(stateDropdown));
    } else {
        jQuery(existingDropdown).replaceWith(jQuery(stateDropdown));
    }

    jQuery(stateDropdown).change({ 'stateFieldName': stateFieldName }, handleStateChanged);
    jQuery(stateDropdown).change();

    document.getElementById('ddl_' + stateFieldName).tabIndex = document.getElementById(stateFieldName).tabIndex;
}

// Sets the value of the country field to the newly selected value and reconfigures the dependent state dropdown.
function handleCountryChanged(eventData) {
    var stateFieldName = eventData.data.stateFieldName;
    var selectedCountry = setFieldFromDropdown(eventData.data.countryFieldName);

    loadStateField(stateFieldName, selectedCountry);
}

// Configures the country field to be a dropdown based on the Country object.
function initializeDynamicStateField(countryFieldName, stateFieldName) {
    var countryField = jQuery('#' + countryFieldName);
    var selectedCountry = jQuery(countryField).val();

    jQuery(countryField).change({ 'countryFieldName': countryFieldName, 'stateFieldName': stateFieldName }, handleCountryChanged);

    loadStateField(stateFieldName, selectedCountry);
}
